import React from 'react';

import { Paper } from '@mui/material';

import classNames from 'classnames';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import classes from './NoteItem.module.scss';
import { Note } from '../../../interfaces/note';
import { AssignedToBlock } from './AssignedToBlock/AssignedToBlock';
import { EditDeleteButtonGroup } from '../../../../shared/components/table-components';
import { getFormattedDate } from '../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../shared/constants/apiDateFormat';

type NoteItemProps = {
  note: Note;
  onEdit: (note: Note) => void;
  onDelete: (noteId: number) => void;
};

const NoteItem = ({ note, onEdit, onDelete }: NoteItemProps) => {
  const handleDelete = () => {
    onDelete(note.id);
  };

  const handleEdit = () => {
    onEdit(note);
  };

  return (
    <Paper variant="roundedBox" className={classes.container}>
      <div className={classes.infoBlock}>
        <AssignedToBlock users={note.users} />
        <p className={classNames(classes.noteText, 'private-info')}>{note.note}</p>
      </div>
      <div>
        <div className={classes.controlsBox}>
          <div className={classes.dateView}>
            <CalendarTodayRoundedIcon fontSize="small" color="tertiary" />
            <span>{getFormattedDate(note.createdOn, localDataFormat)}</span>
          </div>
          <EditDeleteButtonGroup
            onEdit={handleEdit}
            onDelete={handleDelete}
            modalTitle="Are you sure you want to delete note?"
            size="medium"
          />
        </div>
      </div>
    </Paper>
  );
};

export { NoteItem };
